import { Component, Inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AuthService,
  BUILD_INFO,
  UserService,
  NotificationService,
  AppSettingsService,
  FireAnalyticsService,
} from '@viso/core/data-access';
import { BuildInfo, UnreadNotification, User } from '@viso/core/models';
import { Observable } from 'rxjs';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Platform } from '@ionic/angular';
import { IonicUtilityService } from '@viso/core/utilities';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'viso-layout',
  templateUrl: './layout.page.html',
  styleUrls: ['./layout.page.scss'],
  standalone: false,
})
export class LayoutPage {
  pageData = {
    'vendor-contact-us-mobile': '',
    'vendor-contact-us-email': '',
    'partner-playstore-link': '',
    'partner-appstore-link': '',

  };
  user$: Observable<User> = this.userService.userObservable$;
  isAndroid!: boolean;
  isPwa!: boolean;
  appVersion = '';
  count: UnreadNotification;
  isNative: boolean;
  earnings: any;
  constructor(
    private auth: AuthService,
    private userService: UserService,
    private platform: Platform,
    private ionic: IonicUtilityService,
    private appSettings: AppSettingsService,
    private notification: NotificationService,
    private fireAnalytics: FireAnalyticsService,
    @Inject(BUILD_INFO) private buildInfo: BuildInfo
  ) {}

  ngOnInit() {
    this.notification.getUnreadNotification().subscribe((count) => {
      if (count) {
        this.count = count;
      }
    });

    this.isNative = Capacitor.isNativePlatform();
    this.isAndroid = this.platform.is('android');
    this.isPwa = this.platform.is('pwa');

    if (this.platform.is('android') || this.platform.is('ios')) {
      this.getAppInfo();
    } else {
      this.appVersion = this.buildInfo.version;
    }

      // console.log(this.pageData)
    this.appSettings
      .getSettings(['vendor-contact-us-mobile', 'vendor-contact-us-email', 'partner-playstore-link', 'partner-appstore-link'])
      .subscribe((res) => {
        res.forEach((r) => {
          this.pageData[r.app_key] = r.app_value;
        });
      });

    this.user$.subscribe(user => {
      if (user) {
        this.userService.getVendorEarning(user.id, user.user_type).subscribe(earnings => {
          this.earnings = earnings;
        });
      }
    });
  }

  async getAppInfo() {
    const info = await App.getInfo();
    this.appVersion = info.version;
  }

  async exit() {
    await this.ionic.confirmation(
      'Are you sure you want exit the App?',
      { ok: 'Okay', cancel: 'Cancel' },
      (isClosed: boolean) => {
        if (isClosed) {
          if (this.isPwa) {
            window.close();
          } else {
            App.exitApp();
          }
        }
      }
    );
  }

  async logout() {
    await this.ionic.confirmation(
      'Are you sure you want to Logout?',
      { ok: 'Yes', cancel: 'No' },
      (isLogout: boolean) => {
        if (isLogout) {
          this.user$.subscribe(user => {
            this.fireAnalytics.logEvent('logout', {
              user_id: user.id,
              user_type: 'vendor'
            });
          });
          this.auth.logout();
        }
      }
    );
  }
}

@NgModule({
    declarations: [LayoutPage],
    exports: [LayoutPage],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
    ],
    providers: []
})
export class RegisterPageModule {}
